<template>
  <div class="dashboard__overview">
    <div class="row">
      <div class="col-sm-6 mix__chart mix__chart--mfg">
        <div class ="chart__wrapper">
          <ChartMixVendor class="chart__mix-sales"></ChartMixVendor>
        </div>
      </div>
      <div class="col-sm-6 mix__chart mix__chart--tier">
        <div class="chart__wrapper">
          <ChartMixTier class="chart__mix-sales"></ChartMixTier>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import ChartMixVendor from './ChartMixVendor.vue';
  import ChartMixTier from './ChartMixTier.vue';

  //////////////////////////////////////
  // Import of libraries
  //////////////////////////////////////
  export default {
    name: 'OverviewMixChart',
    components: {
      ChartMixVendor,
      ChartMixTier,
    },
  };
</script>
